var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePaymentsSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 109,
    viewBox: "0 0 107 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.469 30.3663C10.9411 21.4612 17.8015 13.9752 26.2836 8.74515C34.7656 3.51504 44.5351 0.746863 54.5 0.750003C68.9856 0.750003 81.1546 6.07125 90.4588 14.7519L75.0486 30.1674C69.4748 24.8408 62.3905 22.1264 54.5 22.1264C40.4981 22.1264 28.6463 31.5864 24.4269 44.2875C23.3519 47.5125 22.7391 50.9525 22.7391 54.5C22.7391 58.0475 23.3519 61.4875 24.4269 64.7125C28.6516 77.419 40.4981 86.8736 54.5 86.8736C61.7294 86.8736 67.8838 84.9655 72.6998 81.7405C75.4917 79.9023 77.882 77.517 79.726 74.7288C81.57 71.9406 82.8294 68.8075 83.4283 65.5188H54.5V44.7283H105.122C105.756 48.2435 106.1 51.9093 106.1 55.7201C106.1 72.0924 100.241 85.8739 90.0717 95.2264C81.1815 103.439 69.0125 108.25 54.5 108.25C47.4407 108.253 40.45 106.864 33.9274 104.164C27.4049 101.464 21.4784 97.505 16.4867 92.5133C11.495 87.5216 7.53591 81.5951 4.83572 75.0726C2.13553 68.5501 0.747179 61.5593 0.750004 54.5C0.750004 45.8248 2.82475 37.6225 6.469 30.3663Z",
    fill: "#023A5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePaymentsSocial);
export default __webpack_public_path__ + "static/media/GooglePaymentsSocial.d42065ffd84c6f2cd4a5de6f11ab3a85.svg";
export { ForwardRef as ReactComponent };